import { Destinatario } from "../models/Destinatario";

export class DestinatarioMenu {
    public id: String;
    public destinatario: Destinatario;
    public fechaCreacion: string;
    public fechaActualizacion: string;
    public usuarioActualizacion: string;
    constructor(
        id:string,
        destinatario:Destinatario,
        fechaCreacion: string,
        fechaActualizacion: string,
        usuarioActualizacion: string
      ) {
        this.id = id;
        this.destinatario = destinatario;
        this.fechaCreacion = fechaCreacion;
        this.fechaActualizacion = fechaActualizacion;
        this.usuarioActualizacion = usuarioActualizacion;
      }
}
